<template>
  <div class="absence-reasons text-dark pad-1">
    <div class="absence-reasons__header">
      <h2>{{ i18n['absence_reasons'] }}</h2>
      <button class="do-bttn do-bttn--submit"
              @click="setIsCreateAbsenceReason(true)"
              :content="'<p class=' + 'tooltip-shortcut' + '>' + $t('vue2.common.press') + '<span>N</span></p>'"
              v-tippy="{
                    arrow: true,
                    placement : 'bottom'
                  }">
        {{ i18n['create_absence'] }}
      </button>
    </div>
    <Loader v-if="isLoading"></Loader>
    <template v-else>
      <h2 class="text-explainer" v-if="absenceReasonsActive.length === 0">{{ i18n['no_absence_reasons_created'] }}</h2>
      <AbsenceReasonsTable
        v-else
        :items="absenceReasonsActive"
        @editAbsencePrivate="editAbsencePrivate"
        @toggleArchived="toggleArchived">
      </AbsenceReasonsTable>
      <p class="text-link marg-1-top" @click="isShowArchived = !isShowArchived"
         v-if="absenceReasonsArchived.length > 0">{{ isShowArchived ? i18n['hide_archived'] : i18n['show_archived'] }}
        {{ '(' + absenceReasonsArchived.length + ')' }}</p>
      <AbsenceReasonsTable
        v-if="isShowArchived && absenceReasonsArchived.length > 0"
        :items="absenceReasonsArchived"
        @editAbsencePrivate="editAbsencePrivate"
        @toggleArchived="toggleArchived">
      </AbsenceReasonsTable>
    </template>
    <AbsenceReasonsCreate
      v-if="isCreateAbsenceReason"
      :reasons="absenceReasons"
      @create="handleCreateReason"
      @cancel="setIsCreateAbsenceReason(false)"
    />
  </div>
</template>

<script>
import docendo from '../../docendo'
import AppToggle from '../common/AppToggle.vue'
import Loader from '../common/Loader.vue'
import DModal from '../common/DModal.vue'
import AssignHoursEmploymentEnded from '../AssignHours/AssignHoursEmploymentEnded.vue'
import AbsenceReasonsTable from './AbsenceReasonsTable.vue'
import eventbus from '../../eventbus'
import AbsenceReasonsCreate from './AbsenceReasonsCreate.vue'

const I18N = {
  da: {
    absence_reasons: 'Fraværsårsager',
    create_absence: 'Opret fraværsårsag',
    title: 'Navn',
    need_a_title: 'Mangler et navn',
    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
    title_already_exists: 'Navnet findes i forvejen',
    hide_archived: 'Skjul arkiverede',
    show_archived: 'Vis arkiverede',
    hide_title: 'Skjul titel'
  },
  nb: {
    absence_reasons: 'Fraværsårsaker',
    create_absence: 'Opprett fraværsårsak',
    title: 'Navn',
    need_a_title: 'Mangler et navn',
    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
    title_already_exists: 'Navnet finnes allerede',
    hide_archived: 'Skjul arkiverte',
    show_archived: 'Vis arkiverte'
  },
  en: {
    absence_reasons: 'Absence reasons',
    create_absence: 'Create absence reason',
    title: 'Name',
    need_a_title: 'Missing a name',
    no_absence_reasons_created: 'No absence reasons created',
    title_already_exists: 'The name already exists',
    hide_archived: 'Hide archived',
    show_archived: 'Show archived'
  }
}
export default {
  components: {AbsenceReasonsTable, AssignHoursEmploymentEnded, DModal, Loader, AppToggle, AbsenceReasonsCreate},
  data () {
    return {
      isLoading: false,
      absenceReasons: [],
      newReasonTitle: '',
      isCreateAbsenceReason: false,
      errors: {},
      isCreating: false,
      theUpdatingReasonId: null,
      _keyListener: null,
      isShowArchived: false
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        setTimeout(_ => {
          el.focus()
        }, 150)
      }
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    absenceReasonsSorted () {
      return this.absenceReasons.slice().sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    absenceReasonsArchived () {
      return this.absenceReasonsSorted.filter(reason => reason.archived)
    },
    absenceReasonsActive () {
      return this.absenceReasonsSorted.filter(reason => !reason.archived)
    }
  },
  watch: {
    schoolId () {
      this.readAbsenceReasons()
    }
  },
  methods: {
    handleCreateReason (titleAndDefaultPrivate) {
      const title = titleAndDefaultPrivate.title
      const defaultPrivate = titleAndDefaultPrivate.defaultPrivate
      this.isCreating = true
      docendo.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, success => {
        this.absenceReasons.push(success)
        this.setIsCreateAbsenceReason(false)
      }, failure => {
        console.log('error', failure)
      })
    },
    editAbsencePrivate (reason) {
      const defaultPrivate = !reason.default_private
      this.$nextTick(_ => {
        docendo.schoolAbsenceSubjectsUpdate(reason.id, reason.school_id, reason.name, reason.color, defaultPrivate, success => {
          if (success.status === 'error') {
            eventbus.toast = {text: success.message, 'success': false}
            return
          }
          this.updateAbsenceReason(success)
        }, failure => {
          console.log({failure})
        })
      })
    },
    updateAbsenceReason (updatedReason) {
      const idx = this.absenceReasons.findIndex(r => r.id === updatedReason.id)

      if (idx !== -1) {
        this.$set(this.absenceReasons, idx, updatedReason)
      }
      this.theUpdatingReasonId = null
    },
    toggleArchived (reason) {
      const isArchived = reason.archived
      this.theUpdatingReasonId = reason.id
      if (!isArchived) {
        docendo.schoolAbsenceSubjectsArchive(reason.school_id, reason.id,
          success => {
            if (success.status === 'error') {
              eventbus.toast = {text: success.message, 'success': false}
              return
            }
            this.updateAbsenceReason(success)
          },
          failure => {
            console.log('failed!')
          }
        )
      } else {
        docendo.schoolAbsenceSubjectsUnarchive(reason.school_id, reason.id,
          success => {
            this.updateAbsenceReason(success)
          },
          failure => {
            console.log('failed!')
          })
      }
    },
    setIsCreateAbsenceReason (bool) {
      this.isCreateAbsenceReason = bool
      if (!bool) {
        this.newReasonTitle = ''
        this.errors = {}
        this.isCreating = false
      }
    },
    readAbsenceReasons () {
      if (!this.schoolId) {
        return
      }
      this.isLoading = true
      docendo.schoolAbsenceSubjectsList(this.schoolId, true, success => {
        this.absenceReasons = success
        this.isLoading = false
      }, failure => {
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.readAbsenceReasons()
    this._keyListener = e => {
      if (e.key === 'n' && e.target.tagName.toUpperCase() === 'BODY') {
        this.setIsCreateAbsenceReason(true)
      }
    }

    document.addEventListener('keydown', this._keyListener)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  }
}
</script>

<style scoped>
.absence-reasons__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.absence-reasons__header .do-bttn--submit {
  padding: 0rem 2rem;
  height: 32px;
}

.do-modal__body {
  background: #edf0f5;
  max-height: calc(100vh - 105px);
  overflow-y: auto;
  overscroll-behavior: contain;
  min-width: 500px;
  padding: 2rem;
}

.do-modal__footer {
  gap: 1rem;
}

.do-bttn.do-bttn--small {
  font-size: 11px;
  height: auto;
  padding: 5px 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pad-1 {
  padding: 1rem !important;
}

</style>



// WEBPACK FOOTER //
// AbsenceReasons.vue?69a31904